import React, { useEffect } from 'react'

import { type To, useNavigate } from 'react-router'

//	///////////////////////
//	MARK: TYPES
export interface IHelpersRedirectProps {
  to: To
}

//	///////////////////////
//	MARK: EXPORTS
const RedirectInternal: React.FC<IHelpersRedirectProps> = (props) => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate(props.to)
  }, [navigate, props.to])

  return null
}

export const Redirect = React.memo(RedirectInternal) as typeof RedirectInternal
